import ReactECharts from "echarts-for-react";

export default function LineChart({ data }) {
  const categories = [
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];

  const values = categories.map((month) =>
    data?.[month] !== undefined ? data[month] : null,
  );

  const options = {
    color: ["#9b9aff"],
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "none",
      },
    },
    grid: {
      left: "5%",
      right: "5%",
      bottom: "1%",
      top: "15%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      data: categories,
      boundaryGap: false,
      splitLine: { show: false },
    },
    yAxis: {
      type: "value",
      splitNumber: 3,
      axisLabel: { show: false }, // ✅ removes y-axis labels
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { show: false },
    },
    series: [
      {
        name: "SAR Value",
        type: "line",
        data: values,
        smooth: true,
        symbol: "circle",
        symbolSize: 6,
        lineStyle: {
          width: 3,
        },
        areaStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: "rgba(155,154,255,0.6)" },
              { offset: 1, color: "rgba(155,154,255,0.05)" },
            ],
          },
        },
        label: {
          show: true,
          position: "top",
          formatter: ({ value }) => (value !== null ? value : ""),
        },
      },
    ],
  };

  return <ReactECharts option={options} style={{ height: 250 }} />;
}
